import React, { useState, useRef } from "react";
import { StaticRoutes } from "../routes";
import { useNavigate, Link } from "react-router-dom";
import styles from "./TripBoard.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import AirlinesSelect from "../../components/AirlinesSelect";
import PreviewItem from "../../components/PreviewItem/PreviewItem";
import FeaturesList from "../../components/FeaturesList/FeaturesList";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import logo from "../../assets/BidProPlusTripBoardLogo.png";
import img from "../../assets/macbook.png";
import img2 from "../../assets/AA-Trip-Board main.jpg";
import { CSSTransition } from "react-transition-group";

export const TripBoard = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
  features = [
    {
      icon: "fa-eye",
      header: "View Available Trips",
      description:
        "View a list of posted and open time trips that are available for pickup.",
    },
    {
      icon: "fa-plane",
      header: "Post & Pick Up Trips",
      description:
        "Have a trip on your schedule you don't want to fly? Post it for another pilot to pick up. Need to earn some extra trips? Easily pick up an additional trip or two.",
    },
    {
      icon: "fa-sharp fa-dollar-sign",
      header: "Estimated Pay & Credit",
      description:
        "Your total pay and credit is estimated and displayed next to your schedule.",
    },
    {
      icon: "fa-message",
      header: "Text & Email Notifications",
      description:
        "Get notified via text message and/or email when new trips become available, or when your posted trip is picked up.",
    },
    {
      icon: "fa-bell",
      header: "Custom Notifications",
      description:
        "Only interested in open time trips, or trips based out of Miami? Configure your notification settings to get notified about the exact trips you want.",
    },
    {
      icon: "fa-mobile-screen-button",
      header: "Mobile-Friendly",
      description:
        "The Trip Board is designed to work seamlessly across all your devices, including smartphones.",
    },
  ],
  featuresAA = [
    {
      icon: "fa-eye",
      header: "View Available Trips",
      description:
        "View the current list of Open, Posted and Sick Pending trips for any Base, Seat or Equipment.",
    },
    {
      icon: "fa-plane",
      header: "Pick Up Trips",
      description: "Easily add more trips to your schedule in just a few taps.",
    },
    {
      icon: "fa-sharp fa-dollar-sign",
      header: "Projected Pay",
      description: "View your hourly rate and total projected pay.",
    },
    {
      icon: "fa-user",
      header: "See Who You're Flying With",
      description:
        "Quickly see who you're flying with and view their contact information.",
    },
    {
      icon: "fa-plane",
      header: "Drop Trips",
      description:
        "Drop a sequence to the Open Time list or directly to a specific pilot.",
      flip: "horizontal",
    },
    {
      icon: "fa-mobile-screen-button",
      header: "iOS-Friendly",
      description:
        "The Trip Board for American Airlines is available for both iPhone and iPad.",
    },
  ],
}) => {
  const navigate = useNavigate();
  const acceptingSignUps = false;
  const [isOpen, setIsOpen] = useState(false);
  const collapseRef = useRef(null);

  const toggleCollapse = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));
  const [selectedAirline, setSelectedAirline] = useState("UPS");

  const handleAirlineChange = (newValue) => {
    setSelectedAirline(newValue);
  };

  const options = [{ label: "UPS" }, { label: "AA" }];

  const handleUPSBtnClick = () => {
    navigate(StaticRoutes.UPSPricing);
  };

  const handleAABtnClick = () => {
    navigate(StaticRoutes.AAPricing);
  };

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div className={styles.logoImageContainer}>
        <img className={styles.Logo} src={logo} alt="BidPro Product Logo" />
      </div>
      <div className={styles.animateContainer}>
        <div className={`${styles.topContainer} container-fluid`}>
          <AirlinesSelect options={options} onChange={handleAirlineChange} />
        </div>
        {selectedAirline === "UPS" && (
          <div id="UPS" className={styles.container}>
            {/* Page Header */}
            <PageHeader
              image={img}
              heading="UPS Airline"
              para="Since 2017, BidPro has been working with the Independent Pilots Association (IPA) to provide the web-based Trip Board application."
              firstfooter="Already a UPS pilot with a BidPro account?"
              secondfooter={
                <>
                  Click{" "}
                  <Link to="https://tripboard.bidproplus.com/login?ReturnUrl=%2F">
                    here
                  </Link>{" "}
                  to go to the Trip Board.
                </>
              }
            />

            {/* Product Features */}
            <div className={styles.row}>
              <FeaturesList features={features} colorBlue={false} />
            </div>
            {/* Product Preview Items */}
            <div className={styles.featureColumn}>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={true}
                  header={"View Your Schedule"}
                  description={
                    "Your awarded schedule is displayed in a calendar. Click any of the trips in your schedule to view more details about that trip."
                  }
                  imgs={[
                    {
                      src: "viewschedule.png",
                      alt: "Light and Dark Modes Image",
                    },
                  ]}
                />
              </div>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={false}
                  header={"Post Trips"}
                  description={
                    "Have a trip in your schedule that you don't want to fly? With just a few clicks, you can post it for another pilot to pick up."
                  }
                  imgs={[
                    { src: "post-trip.png", alt: "Compare Progress Image" },
                  ]}
                />
              </div>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={true}
                  header={"Pick Up Trips"}
                  description={
                    "Need some extra trips? Pick up an Open Time or Posted trip."
                  }
                  imgs={[
                    {
                      src: "pick-up-trip.png",
                      alt: "Light and Dark Modes Image",
                    },
                  ]}
                />
              </div>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={false}
                  header={"Customize Your Notifications"}
                  description={
                    <>
                      <div className={styles.p}>
                        You can receive notifications for trips that fit in your
                        schedule, have layovers at selected gateways, and&nbsp;
                        <a
                          href="#TripBoardMore"
                          onClick={toggleCollapse}
                          role="button"
                          aria-expanded={isOpen}
                          className={styles.moreToggle}
                        >
                          more {isOpen ? "▲" : "▼"}
                        </a>
                        <CSSTransition
                          in={isOpen}
                          timeout={300}
                          classNames={{
                            enter: styles.slideEnter,
                            enterActive: styles.slideEnterActive,
                            exit: styles.slideExit,
                            exitActive: styles.slideExitActive,
                          }}
                          unmountOnExit
                          nodeRef={collapseRef}
                        >
                          <div ref={collapseRef} className="card card-body">
                            <div
                              id="TripBoardMore"
                              className={styles.dropDownMenu}
                            >
                              <p>Get notifications about trips that...</p>
                              <ul>
                                <li>Fit in your current schedule</li>
                                <li>Have layovers at selected gateways</li>
                                <li>Have CML in first duty period</li>
                                <li>Have CML in last duty period</li>
                                <li>
                                  First Operating Leg starts at selected gateway
                                </li>
                                <li>
                                  Last Operating Leg starts at selected gateway
                                </li>
                                <li>
                                  Have less than or equal to a specified number
                                  of duty days
                                </li>
                              </ul>
                            </div>
                          </div>
                        </CSSTransition>
                      </div>
                    </>
                  }
                  imgs={[
                    {
                      src: "notifications.png",
                      alt: "Light and Dark Modes Image",
                    },
                  ]}
                />
              </div>
            </div>
            {/* Get Started */}
            <div className={styles.callToActionColumn}>
              <h2>Ready to get started?</h2>
              <button className={styles.button} onClick={handleUPSBtnClick}>
                SIGN UP
              </button>
            </div>
          </div>
        )}
        {selectedAirline === "AA" && (
          <div id="AA" className={styles.container}>
            {/* Page Header */}
            <PageHeader
              image={img2}
              heading="American Airline"
              para="BidPro has provided Bidding and Trip Trade applications for AA Crewmembers since 1992."
              firstfooter="Already a AA pilot with a BidPro account?"
              secondfooter={
                <>
                  Click{" "}
                  <Link to="https://apps.apple.com/us/app/bidpro-tripboard-for-aa/id1427714381">
                    here
                  </Link>{" "}
                  to download the Trip Board app.
                </>
              }
            />

            {/* Product Features */}
            <div className={styles.row}>
              <FeaturesList features={featuresAA} colorBlue={false} />
            </div>
            {/* Product Preview Items */}
            <div className={styles.featureColumn}>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={true}
                  header={"View Your Schedule"}
                  description={
                    "View your schedule on the go from your iPhone or iPad."
                  }
                  imgs={[
                    {
                      src: "AA-Trip-Board main.jpg",
                      alt: "Light and Dark Modes Image",
                    },
                  ]}
                />
              </div>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={false}
                  header={"Pick Up & Drop Trips"}
                  description={
                    "Drop or Post your sequence into Open Time or, if requested, simply transfer your trip directly to another pilot."
                  }
                  imgs={[
                    {
                      src: "AA-Trip-Board pickup.jpg",
                      alt: "Compare Progress Image",
                    },
                  ]}
                />
              </div>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={true}
                  header={"Access TASC Sabre"}
                  description={
                    "Effortlessly access TASC Sabre from within the Trip Board app."
                  }
                  imgs={[
                    {
                      src: "AA-Trip-Board sabre.jpg",
                      alt: "Light and Dark Modes Image",
                    },
                  ]}
                />
              </div>
              <div className={styles.row}>
                <PreviewItem
                  imgRight={false}
                  header={"View Projected Pay"}
                  description={"View your hourly rate and total projected pay."}
                  imgs={[
                    {
                      src: "notifications.png",
                      alt: "Light and Dark Modes Image",
                    },
                  ]}
                />
              </div>
            </div>
            {/* Get Started */}
            {acceptingSignUps ? (
              <>
                <div className={styles.callToActionColumn}>
                  <h2>Ready to get started?</h2>
                  <button className={styles.button} onClick={handleAABtnClick}>
                    SIGN UP
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className={styles.callToActionColumn}>
                  <h2>We're Sorry.</h2>
                  <h3>Sign ups are currently unavailable for this airline.</h3>
                  <p>
                    Please contact us <a href="/contact">here.</a>
                  </p>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <Footer lists={footerLists} inverse={true} />
    </>
  );
};

export default TripBoard;
